/**
 * @generated SignedSource<<91de9a760411e35088d176e33eb98927>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type create_reminders_reviewed_params = {
  reminder_ids?: ReadonlyArray<number> | null;
};
export type recoilUseMarkPackageReportRemindersResolvedMutation$variables = {
  params: create_reminders_reviewed_params;
};
export type recoilUseMarkPackageReportRemindersResolvedMutation$data = {
  readonly _sys_create_reminders_reviewed: {
    readonly reminders_reviewed_ids: ReadonlyArray<number> | null;
  };
};
export type recoilUseMarkPackageReportRemindersResolvedMutation = {
  response: recoilUseMarkPackageReportRemindersResolvedMutation$data;
  variables: recoilUseMarkPackageReportRemindersResolvedMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "params"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "params",
        "variableName": "params"
      }
    ],
    "concreteType": "create_reminders_reviewed_output",
    "kind": "LinkedField",
    "name": "_sys_create_reminders_reviewed",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "reminders_reviewed_ids",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "recoilUseMarkPackageReportRemindersResolvedMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "recoilUseMarkPackageReportRemindersResolvedMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "8c2904f6c512c21fcc056d458dc1e6ec",
    "id": null,
    "metadata": {},
    "name": "recoilUseMarkPackageReportRemindersResolvedMutation",
    "operationKind": "mutation",
    "text": "mutation recoilUseMarkPackageReportRemindersResolvedMutation(\n  $params: create_reminders_reviewed_params!\n) {\n  _sys_create_reminders_reviewed(params: $params) {\n    reminders_reviewed_ids\n  }\n}\n"
  }
};
})();

(node as any).hash = "7bbd8fd7fdf2687be8d41ad1fc1fcce3";

export default node;
